/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */


export class Tour {
  public eventIds: string[] = [];
  public formattedStart: string;
  public formattedEnd: string;

  constructor(public id: string, public name: string, public startTimestamp: number, public endTimestamp: number){}

  static fromSnapshots(snapshot: any) {
    return Object.keys(snapshot.val()).map(key => Tour._fromSnapshot(key, snapshot.val()[key]));
  }

  private static _fromSnapshot(key: string, {name, start, end}) {
    return new Tour(key, name, start, end);
  }
}



// WEBPACK FOOTER //
// ./src/models/Tour.ts